import type { WizardOperation } from "./types";

export class OperationRegistry<TOperation extends WizardOperation> {
  private readonly operations = new Map<TOperation["type"], TOperation>();

  register = (operation: TOperation): void => {
    this.operations.set(operation.type, operation);
  };

  unregister = (operation: TOperation): void => {
    this.operations.delete(operation.type);
  };

  clear = (): void => {
    this.operations.clear();
  };

  getOperations = (): TOperation[] => {
    return [...this.operations.values()];
  };
}
